import { injectable, inject } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcher } from '@dm-portal/json-rpc-dispatcher';
import DITypes from '@dm-portal/json-rpc-dispatcher/DITypes';

import { IScheduleDemoPayload } from '@framework/ui/Organisms/ScheduleDemo/vo/ScheduleDemoPayload';

@injectable()
class ScheduleDemoRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcher,
  ) {}

  requestScheduledDemoPublic = async (payload: IScheduleDemoPayload) => {
    const request = new Request('dm_portal.request_scheduled_demo_public', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  requestScheduledDemoPrivate = async (payload: IScheduleDemoPayload) => {
    const request = new Request('dm_portal.request_scheduled_demo', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };
}

export default ScheduleDemoRepository;
